import { apiKeys } from '../Utils/Utils';

const GoogleMap = (mapEl) => {

	window.initMap = function() {
		// JS API is loaded and available

		const lat = parseFloat(mapEl.getAttribute('data-lat'));
		const lng = parseFloat(mapEl.getAttribute('data-lng'));
		let zoom = parseFloat(mapEl.getAttribute('data-zoom'));
		if(!zoom || zoom <= 0) {
			zoom = 16;
		}

		const map = new google.maps.Map(mapEl, {
			center: {lat: lat, lng: lng},
			zoom: zoom,
			streetViewControl: false,
			mapTypeId: "roadmap",
			//disableDefaultUI: true,
			mapTypeControl: false,
		});

		// Set custom marker
		const image = mapEl.getAttribute('data-pin');
		new google.maps.Marker({
			position: { lat: lat, lng: lng },
			map,
			icon: image,
		});

		// Set styled overlay
		const styles = {
			default: [],
			silver: [
				{
					elementType: "geometry",
					stylers: [{ color: "#EAE7E4" }],
				},
				{
					elementType: "labels.icon",
					stylers: [{ visibility: "off" }],
				},
				{
					elementType: "labels.text.fill",
					stylers: [{ color: "#616161" }],
				},
				{
					elementType: "labels.text.stroke",
					stylers: [{ color: "#f5f5f5" }],
				},
				{
					featureType: "administrative.land_parcel",
					elementType: "labels.text.fill",
					stylers: [{ color: "#bdbdbd" }],
				},
				{
					featureType: "poi",
					elementType: "geometry",
					stylers: [{ color: "#eeeeee" }],
				},
				{
					featureType: "poi",
					elementType: "labels.text.fill",
					stylers: [{ color: "#757575" }],
				},
				{
					featureType: "poi.park",
					elementType: "geometry",
					stylers: [{ color: "#e5e5e5" }],
				},
				{
					featureType: "poi.park",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9e9e9e" }],
				},
				{
					featureType: "road",
					elementType: "geometry",
					stylers: [{ color: "#ffffff" }],
				},
				{
					featureType: "road.arterial",
					elementType: "labels.text.fill",
					stylers: [{ color: "#757575" }],
				},
				{
					featureType: "road.highway",
					elementType: "geometry",
					stylers: [{ color: "#dadada" }],
				},
				{
					featureType: "road.highway",
					elementType: "labels.text.fill",
					stylers: [{ color: "#616161" }],
				},
				{
					featureType: "road.local",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9e9e9e" }],
				},
				{
					featureType: "transit.line",
					elementType: "geometry",
					stylers: [{ color: "#e5e5e5" }],
				},
				{
					featureType: "transit.station",
					elementType: "geometry",
					stylers: [{ color: "#eeeeee" }],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [{ color: "#c9c9c9" }],
				},
				{
					featureType: "water",
					elementType: "labels.text.fill",
					stylers: [{ color: "#9e9e9e" }],
				},
			],
		};
		map.setOptions({ styles: styles['silver'] });
		//geocodeAddress();

	};

	//console.log('apiKey',apiKeys.googleMaps);

	// Create the script tag, set the appropriate attributes
	const script = document.createElement('script');
	const apiKey = apiKeys.googleMaps;
	script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
	script.async = true;
	document.head.appendChild(script);
};

export default GoogleMap;